import { render, staticRenderFns } from "./BulkUpdateModal.vue?vue&type=template&id=7bf938c6&"
import script from "./BulkUpdateModal.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports